<div class="common-modal__container">
    <!-- Cabecera -->
    <div class="common-modal__header">
      <span class="common-modal__text-header"
      [afTranslate]="'automatic-post-process-modal.automatic-post-process-title'">
        _Publicaciones automáticas en función del proceso
      </span>
    </div>
    <!-- Contenedor -->
    <div class="common-modal__content-scroll">
      <p class="common-modal__content-header-info"
        [afTranslate]="'automatic-post-process-modal.info-modal'">
        _Cuando se avance el proceso al paso seleccionado, se mostrarán de forma automática en el portal de seguimiento todos los documentos de la consulta.
      </p>
      <div class="upload-document__form-container">
        <div class="common-container__mandatory-obligatory-message-form">
					<span class="common-tag__mandatory-text-asterisk">*</span>
					<span class="common-tag__mandatory-label-text-obligatory-message"
						[afTranslate]="'common.required-fields'">
						_Campos obligatorios
					</span>
        </div>
        <field-type-list-simple [field]="automaticPostProcessModal.processSteps"
					[listValues]="automaticPostProcessModal.processStates"
					[preSelectItem]="item.stateId"
					(itemSelected)="itemSelected('stateId', $event)">
        </field-type-list-simple>
      </div>
    </div>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_cancelar
        </span>
      </button>
      <button class="common-button__text"
        (click)="validateProcess()">
        <span class="common-button__text-title"
          [afTranslate]="'common.save'">
          _guardar
        </span>
      </button>
    </div>
</div>
